import { useTranslator, useDateFormatter } from '@bluebeam/react-i18n';
import OverlaySection from 'components/Overlays/OverlaySection';
import HeavyLabel from 'components/Overlays/OverlaySection/OverlaySectionHeavyLabel';
import RFIOverlayAttachments from 'components/Overlays/RFIOverlays/RFIOverlayAttachments';
import { List } from 'immutable';
import React from 'react';
import { RFIAttachment } from 'records/RFIAttachment';
import { SheetVersion } from 'records/SheetVersion';
import { useViewRfiMachine } from './ViewRFIMachine';

const RFIRespContent: React.FC = () => {
  const { translate } = useTranslator(['mapView']);
  const dateFormatter = useDateFormatter({
    dateStyle: 'medium',
  });
  const { viewRfiMachineState } = useViewRfiMachine();
  const { rfi } = viewRfiMachineState.context;
  const { answer, forwardactivity, discussionattachmentids } = rfi;

  const attachedForwardActivity = forwardactivity.filter((activity) =>
    discussionattachmentids.has(activity.id)
  );

  const attachments = answer
    ? answer.attachments.merge(
        attachedForwardActivity.flatMap((activity) => activity.attachments)
      )
    : List<RFIAttachment>();

  const sheetVersions = answer
    ? answer.sheetVersions.merge(
        attachedForwardActivity.flatMap((activity) => activity.sheetVersions)
      )
    : List<SheetVersion>();

  return answer ? (
    <OverlaySection label={translate('mapView:RFIRespContent.officialResp')}>
      <div>
        <HeavyLabel label={translate('mapView:RFIRespContent.response')} />
        <div id="rfi-response">{answer.answer}</div>
      </div>
      {forwardactivity.map((activity) =>
        discussionattachmentids.has(activity.id) ? (
          <div className="mt3" key={activity.id}>
            <HeavyLabel
              label={translate('mapView:RFIRespContent.attachedResponse')}
            />
            <div id="rfi-attached-response">{activity.message}</div>
            <br />
            <div id="rfi-attached-response-signature">
              {`- ${activity.user.profile.firstname} ${
                activity.user.profile.lastname
              }, ${dateFormatter?.format(new Date(activity.timestamp * 1000))}`}
            </div>
          </div>
        ) : null
      )}
      {(attachments.size > 0 || sheetVersions.size > 0) && (
        <div className="oa mt3">
          <RFIOverlayAttachments
            projectId={rfi.projectid}
            attachments={attachments}
            attachedSheetversions={sheetVersions}
          />
        </div>
      )}
    </OverlaySection>
  ) : null;
};

export default RFIRespContent;
